//window?.experiments = (window.experiments != undefined) ? window.experiments : [];
growthHack_v2 = "default";

var GrowthBookInstance = (function () {
  // private members
  var objects = [];
  let trkId = getCookie("trkId"); //localStorage.getItem('trkid');
  if (!trkId) {
    trkId = uuidv4();
    setCookie("trkId", trkId);
    //localStorage.setItem('trkId', trkId);
  }
  // Private Member
  const gb = new growthbook.GrowthBook({
    apiHost: "https://abtests-proxy.tmrw.in",
    clientKey: "sdk-uQUSTOgJ56ASrB7K",
    enableDevMode: false,
    attributes: {
      id: trkId,
      country: "IN",
      browser: navigator.userAgent,
      url: window.location.pathname,
      company: "Urbano",
    },
    trackingCallback: (experiment, result) => {
      logGtmEvent("experiment_viewed", experiment.key, result.variationId);
    },
  });

  // public members, exposed with return statement
  return {
    getVariant: getVariant,
    loadFeatures: loadFeatures,
    isOn: isOn,
  };

  //Public Method
  function getVariant(experiment, variations) {
    window.gtag("event", "experiment_invoked");
    return gb.run({ key: experiment, variations: variations });
  }

  function isOn(featureId) {
    return gb.isOn(featureId);
  }

  async function loadFeatures() {
    return await gb.loadFeatures({ autoRefresh: true });
  }

  function uuidv4() {
    try {
      return crypto.randomUUID();
    } catch (error) {
      console.log("error", error);
      const payload = {
        errorMessage: error.message,
      };
      gaClickEvent("GA_BREAKING_EVENT", payload);
    }
  }

  function setCookie(name, value) {
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() +1);

    // Format the date to GMT format
    const expires = expiryDate.toUTCString();
    
    document.cookie =
      name +
      "=" +
      value +
      "; expires=" +
      expires +
      "; path=/";
  }

  function logGtmEvent(event_name, experiment_name, ab_variant) {
    let gaExpObj = {
      event: event_name,
      experiments: JSON.stringify({
        name: experiment_name,
        variant: ab_variant,
      }),
    };
    dataLayer.push(gaExpObj);
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }
})();
